import styled from 'styled-components';
import { PACKAGE_BRAND_ORANGE } from './package-tier-card-styles';

export const PackagesPanel = styled.div`
  flex: 1;
  position: relative;
  min-height: 0;
  .packages-scroll {
    position: absolute;
    inset: 0;
    overflow: auto;
    padding: 0 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0;
    }
    /* phóng to 20% nội dung panel; zoom trên khối con width auto nên vẫn vừa khung, không tràn ngang */
    & > * {
      zoom: 1.2;
    }
  }
  .program-section {
    background: #fff;
    border-radius: 8px;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
`;

export const ChipGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
`;

export const ChipButton = styled.button`
  min-height: 56px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #E5E6EB;
  background: #fff;
  color: #1D2129;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  .chip-label {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
    font-weight: bold;
  }
  &.active {
    background: ${PACKAGE_BRAND_ORANGE};
    border-color: ${PACKAGE_BRAND_ORANGE};
    color: #fff;
  }
`;

export const ProgramHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  p {
    margin: 0;
  }
  .program-name {
    font-size: 1.75rem;
    font-weight: 600;
    color: #1D2129;
  }
  .program-description {
    margin-top: 4px;
    font-size: 1rem;
    color: #505050;
  }
  .program-price {
    white-space: nowrap;
    font-size: 2rem;
    font-weight: 700;
    color: #1D2129;
  }
  .per-session {
    margin-left: 4px;
    font-size: 1rem;
    font-weight: 400;
    color: #505050;
  }
`;
